import { createIcon } from '../OriginIcon/iconHelper';
import React from 'react';

export default createIcon(
  'Home',
  <React.Fragment>
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </React.Fragment>
);
